import { render, staticRenderFns } from "./TabelaValorAtivacaoMensal.vue?vue&type=template&id=2441772e"
import script from "./TabelaValorAtivacaoMensal.vue?vue&type=script&lang=js"
export * from "./TabelaValorAtivacaoMensal.vue?vue&type=script&lang=js"
import style0 from "./TabelaValorAtivacaoMensal.vue?vue&type=style&index=0&id=2441772e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VIcon,VSimpleTable})
